export enum SessionType {
  BusinessPartner = 'bp',
  NoBusinessPartner = 'nobp',
}
